import ConfigList from 'Model/ConfigList'
import { branch } from 'Model/constants'

class DisabledRelations extends ConfigList
  @className = 'DisabledRelations'

  constructor: ->
    super('disabledRelations')

  @load: ->
    super('disabledRelations', @)

export default DisabledRelations
